module.exports = __webpack_public_path__ + "static/media/marker-highlited.5fdbb2ec.svg";